import request from '@/utils/request';
import axios, { AxiosPromise, AxiosResponse } from 'axios';

interface CommonRes<T> {
  data: T;
  msg: string;
  code: number;
}

interface R<T = any> extends AxiosResponse<CommonRes<T>> {}
const instance = axios.create({});

export const fetchSig = (
  username = ''
): Promise<{
  sdkAppId: number;
  sign: string;
}> => {
  // return instance.get('/video/trtc/sign?username=' + username);
  return request( {
    url: '/video/trtc/sign?username=' + username,
    method: 'get'
  })
};

/**
 * 邀请成员
 */
export function invite(
  inviteeId: string,
  accidentId: string
): AxiosPromise<string> {
  return request({
    url: '/video/trtc/invite',
    method: 'get',
    params: { inviteeId, accidentId }
  });
}

/**
 * 开始录制
 */
export function startMix() {
  return request({
    url: '/video/trtc/start_mix',
    method: 'get'
  });
}
